import { CustomDrawer } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomDrawer)`
  .simplebar-content-wrapper {
    padding: 0 !important;
  }
  .MuiPaper-root {
    height: 100%;
    overflow: auto;
    z-index: inherit;
  }
  .DrawerContentScrollBar_Content {
    height: 100%;
  }

  &.MuiDrawer-root {
    border: none;
  }
`;
